import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ModeService } from '../service/mode.service';

/** Bloquea rutas de administración cuando el perfil activo es Negocio. */
@Injectable({ providedIn: 'root' })
export class ExcludeBusinessModeGuard implements CanActivate {
  constructor(
    private modeService: ModeService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.modeService.activeMode === 'business') {
      this.router.navigate(['/inicio']);
      return false;
    }
    return true;
  }
}
